var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 273.8 154.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #dee4ff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke: #dfe5ff;\n      }\n\n      .cls-3 {\n        stroke: #cf1c4e;\n      }\n\n      .cls-4 {\n        stroke: #2866aa;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Confirm_logout_V2",
    "data-name": "Confirm logout_V2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30.68,
    y1: 96.9,
    x2: 41.5,
    y2: 96.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m7.01,90.64c0,1.74,1.41,3.16,3.16,3.16.84,0,1.6-.33,2.17-.86.61-.58.99-1.39.99-2.3v-.02c0-3.47-2.82-6.29-6.29-6.29s-6.29,2.82-6.29,6.29,2.82,6.29,6.29,6.29h15.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.17,
    y1: 13.63,
    x2: 0.75,
    y2: 13.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.83,7.06v-.02c0-3.47,2.82-6.29,6.29-6.29s6.29,2.82,6.29,6.29c0,3.47-2.82,6.29-6.29,6.29l-24.27.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m243.32,125.4c0,2.35,1.9,4.25,4.25,4.25,1.13,0,2.15-.44,2.92-1.16.82-.78,1.34-1.88,1.34-3.1v-.03c0-4.68-3.79-8.47-8.47-8.47-4.68,0-8.47,3.79-8.47,8.47s3.79,8.47,8.47,8.47h-16.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 222.83,
    y1: 37.72,
    x2: 211.84,
    y2: 37.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m273.05,18.96c-1.05-4.14-4.8-7.21-9.26-7.21-2.93,0-5.56,1.32-7.32,3.4-1.41,1.67-2.25,3.82-2.25,6.17,0,.2.02.4.03.6-.95-.39-1.99-.6-3.08-.6-4.53,0-8.2,3.67-8.2,8.2,0,4.53,3.67,8.2,8.2,8.2h-19.64"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 47.9,
    cy: 51.44,
    r: 2.01
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 235.23,
    y1: 90.28,
    x2: 232.12,
    y2: 90.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 233.68,
    y1: 91.83,
    x2: 233.68,
    y2: 88.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 69.37,
    y1: 137.72,
    x2: 66.26,
    y2: 137.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 67.82,
    y1: 139.28,
    x2: 67.82,
    y2: 136.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 44.79,
    y1: 56.49,
    x2: 38.57,
    y2: 56.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 41.68,
    y1: 59.6,
    x2: 41.68,
    y2: 53.38
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 233.68,
    y1: 96.04,
    x2: 227.46,
    y2: 96.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 230.57,
    y1: 99.15,
    x2: 230.57,
    y2: 92.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m104.2,145.27l21.8,8.09c5.27,1.96,10.88-1.94,10.88-7.56v-59.82c0-5.62-5.61-9.52-10.88-7.56l-21.8,8.09c-3.16,1.17-5.26,4.19-5.26,7.56v43.64c0,3.37,2.1,6.39,5.26,7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m162.12,135.68v3.27c0,4.92-3.99,8.91-8.91,8.91h-16.33v-63.96h16.33c4.92,0,8.91,3.99,8.91,8.91v3.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 174.86,
    y1: 115.91,
    x2: 149.83,
    y2: 115.91
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "166.3 107.96 174.86 115.91 166.3 123.86"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e5336206af89db9b708ec3a2fab00ca4.svg";
export { ForwardRef as ReactComponent };